import { getContrastColor } from "./helpers";

/**
 * Writes all customization colours as CSS custom properties on <html>.
 * Tailwind v3 utilities (bg-primary, text-nav-font etc.) reference these
 * via the `extend.colors` mapping in tailwind.config.js.
 */
export function applyTailwindVars(c: ICustomizationData): void {
    const root = document.documentElement;
    const vars: Record<string, string> = {
        "--color-primary": c.colorPrimaryButtons,
        "--color-secondary": c.colorSecondaryButtons,
        "--color-header-footer": c.colorHeaderFooter,
        "--color-header-footer-font": getContrastColor(c.colorHeaderFooter),
        "--color-nav-bar": c.colorNavigationBar,
        "--color-selected-header": c.colorSelectedHeader,
        "--color-form": c.colorForm,
        "--color-selected-row": c.colorSelectedRow,
        "--color-label": c.colorLabel,
        "--color-paragraph": c.colorParagraphFont,
        "--color-heading-main": c.colorMainHeadingFont,
        "--color-heading-sub": c.colorSubheadingFont,
        "--color-nav-font": c.colorNavigationFont,
        // For navigation header
        "--header-bg": c.colorNavigationBar,
        "--header-text-hover": getContrastColor(c.colorNavigationBar),
        "--header-text": getContrastColor(c.colorNavigationBar),
        "--header-active": c.colorSelectedHeader,
        "--header-text-active": getContrastColor(c.colorSelectedHeader),
        // Explicit color for secondary text
        "--text-secondary": getContrastColor(c.colorSecondaryButtons),
    };
    Object.entries(vars).forEach(([k, v]) => root.style.setProperty(k, v));
}
